import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 right-3 z-50 max-w-[16.5rem]" data-id="element-146" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-147" data-mp="1175z4b7engk2">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-xl border border-line bg-surface p-2.5 shadow-lg shadow-black/40" data-id="element-148" data-mp="116mhkvlo2u6k">
            <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success-soft" data-id="element-149" data-mp="x5azrc91bd8x">
              <CheckIcon size={13} className="text-success" strokeWidth={3} data-id="element-150" data-mp="s5okyydk5oy0" />
            </span>
            <div className="min-w-0" data-id="element-151" data-mp="28jyavwxg7lqy">
              <p className="text-[0.7rem] font-semibold leading-snug text-ink" data-id="element-152" data-mp="28iwmkqrf92ra">
                {buyer.name} compró el Mega Pack
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[0.65rem] text-ink-subtle" data-id="element-153" data-mp="2aol3ubat2827">
                <MapPinIcon size={10} data-id="element-154" data-mp="2fno139kjn9zm" />
                {buyer.city}, Argentina · hace {buyer.minutes} minutos
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="ml-0.5 flex-shrink-0 rounded p-0.5 text-ink-subtle transition-colors duration-150 ease-soft hover:text-ink" data-id="element-155" data-mp="2knsgew9ptyo9">
              <XIcon size={13} data-id="element-156" data-mp="1wwdeh4lupjdj" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}